module.exports = __webpack_public_path__ + "img/20210730_121240.c97a452f.jpg";